import HttpCliente from "servicios/HttpCliente";
import axios from "axios";
import getResponseError from "utils/getResponseError";

//FUNCION PARA NO PEDIR TOKEN DE SEGURIDAD EN LA PETICION
const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const DocBandejaModel = {
  id: undefined,
  nombre: '',
};

/**
 * POST method - Crear una nueva bandeja de documentos
 * @param {DocBandejaModel} docBandeja bandeja de documentos 
 * @return {Promise} Promesa de creación
 */
export const crearDocBandeja = (docBandeja) => {
  return new Promise((resolve, eject) => {
    HttpCliente.post("/DocBandeja", docBandeja)
      .then((response) => {
        resolve([response, undefined, response.status]);
      })
      .catch((error) => {
        const err = getResponseError(error);
        resolve([undefined, err, error.response?.status]);
      });
  });
};

/**
 * GET method - Obtiene una lista con todas las bandejas de documentos
 * @return {Promise} Promesa de obtención
 */
export const obtenerDocBandejas = () => {
  return new Promise((resolve, eject) => {
    HttpCliente.get("/DocBandeja")
      .then((response) => {
        resolve([response, undefined, response.status]);
      })
      .catch((error) => {
        const err = getResponseError(error);
        resolve([undefined, err, error.response?.status]);
      });
  });
};

/**
 * GET method - Obtiene una lista con todas mis bandejas de documentos
 * @return {Promise} Promesa de obtención
 */
export const obtenerMisDocBandejas = () => {
  return new Promise((resolve, eject) => {
    HttpCliente.get("/DocBandeja/mis")
      .then((response) => {
        resolve([response, undefined, response.status]);
      })
      .catch((error) => {
        const err = getResponseError(error);
        resolve([undefined, err, error.response?.status]);
      });
  });
};

/**
 * GET method - Obtiene una bandeja de documentos por Id
 * @param {string} docBandejaId ID del bandeja de documentos
 * @return {Promise} Promesa de obtención
 */
export const obtenerDocBandeja = (docBandejaId) => {
  return new Promise((resolve, eject) => {
    HttpCliente.get("/DocBandeja/" + docBandejaId)
      .then((response) => {
        resolve([response, undefined, response.status]);
      })
      .catch((error) => {
        const err = getResponseError(error);
        resolve([undefined, err, error.response?.status]);
      });
  });
};

/**
 * PUT method - Actualiza una bandeja de documentos
 * @param {DocBandejaModel} docBandeja bandeja de documentos 
 * @return {Promise} Promesa de actualización
 */
export const actualizarDocBandeja = (docBandeja) => {
  return new Promise((resolve, eject) => {
    HttpCliente.put("/DocBandeja", docBandeja)
      .then((response) => {
        resolve([response, undefined, response.status]);
      })
      .catch(error => {
        const err = getResponseError(error);
        resolve([undefined, err, error.response?.status]);
      });
  });
};

/**
 * POST method - Obtiene una lista paginada con todas las bandejas de documentos filtradas por nombre
 * @param {number} pagina N° de página a recuperar
 * @param {number} cantElementos Cantidad de elementos por página
 * @param {string} texto Nombre de bandeja de documentos
 * @return {Promise} Promesa de obtención
 */
export const paginacionDocBandeja = (pagina, cantElementos, texto) => {
  return new Promise((resolve, eject) => {
    HttpCliente.post("/DocBandeja/report", {
      PageNumber: pagina,
      PageSize: cantElementos,
      Texto: texto,
    })
      .then((response) => {
        resolve([response, undefined, response.status]);
      })
      .catch(error => {
        const err = getResponseError(error);
        resolve([undefined, err, error.response?.status]);
      });
  });
};